import $ from 'jquery';

function updateMiniCart(cart) {
  $('.main-header-wrap .cart .count .count-value').text(cart.item_count);
  $('.main-header-wrap .cart .count').toggleClass('count-empty', cart.item_count === 0);

  let itemText;
  const miniCartItemsWrap = $('.mini-cart-items-wrap');
  miniCartItemsWrap.empty();

  if (cart.item_count !== 1) {
    itemText = Theme.cartItemsOther;
  } else {
    itemText = Theme.cartItemsOne;
  }

  $('.mini-cart .options').show();
  miniCartItemsWrap.find('.no-items').hide();
  $('.mini-cart-wrap label').html(`<span class="item-count">${cart.item_count}</span> ${itemText}`);

  for (let i = 0; i < cart.items.length; i++) {
    const item = cart.items[i];

    const productPrice = Shopify.formatMoney(item.line_price, Theme.moneyFormat);
    const variant = item.variant_title ? `<p class='variant'>${item.variant_title}</p>` : '';

    let itemProperties = '';

    if (item.properties) {
      const propertyKeysArray = Object.keys(item.properties);

      for (let j = 0; j < propertyKeysArray.length; j++) {
        if (item.properties[j].length) {
          itemProperties += `
            <p class="property">
              <span class="property-label">${propertyKeysArray[j]}:</span>
              <span class="property-value">${item.properties[j]}</span>
            </p>
          `;
        }
      }
    }

    miniCartItemsWrap.append(`
      <div id="item-${item.variant_id}" class="item clearfix">
        <div class="image-wrap">
            <img alt="${item.title}" src="${item.image}">
            <a class="overlay" href="${item.url}"></a>
        </div>
        <div class="details">
            <p class="brand">${item.vendor}</p>
            <p class="title"><a href="${item.url}">${item.product_title}</a><span class="quantity">× <span class="count">${item.quantity}</span></span></p>
            <p class="price"><span class="money">${productPrice}</span></p>
            ${variant}
            ${itemProperties}
        </div>
      </div>
    `);
  }

  if (Theme.currencySwitcher) {
    $(document.body).trigger('switch-currency');
  }
}

export { updateMiniCart };
